import React from 'react';
import TreeGen from '../tree/TreeGen';
import TreeControlCenter from './TreeControlCenter';
import { TreeProvider } from '../../context/TreeContext';
import '../../styles/components/App.css';

const TreeContainer = () => {
  return (
    <TreeProvider>
      <div className="App">
        <main className="App-content">
          <TreeGen />
        </main>
        <div className="ControlCenter-container">
          <TreeControlCenter />
        </div>
      </div>
    </TreeProvider>
  );
};

export default TreeContainer; 